import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { CircleNotch, WarningCircle } from "@phosphor-icons/react";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const code = params.get("code");
    const errParam = params.get("error_description") || params.get("error");

    if (errParam) {
      setError(errParam);
      return;
    }
    if (!code) {
      setError("Código de autorização ausente");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/microsoft/callback", { code });
        localStorage.setItem("brf_token", data.access_token);
        localStorage.setItem("brf_user", JSON.stringify(data.user));
        toast.success(`Bem-vindo, ${data.user.nome}`);
        if (data.user.role === "vendedor") {
          window.location.href = "/vendedor";
        } else {
          window.location.href = "/hedge";
        }
      } catch (e) {
        const msg = e.response?.data?.detail || "Falha na autenticação";
        setError(msg);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#061729] p-6">
      <div className="max-w-sm w-full border border-[#123a5e] bg-[#0B2D4D] rounded-sm p-8 text-center space-y-4">
        <img src="/logo.png" alt="BRFertil" className="w-12 h-12 object-contain mx-auto" />
        {!error ? (
          <>
            <CircleNotch weight="bold" className="w-8 h-8 text-[#40B6A2] mx-auto animate-spin" />
            <div>
              <p className="text-sm font-semibold">Autenticando...</p>
              <p className="text-xs text-[#8aa9c9] mt-1">Validando sua conta Microsoft</p>
            </div>
          </>
        ) : (
          <>
            <WarningCircle weight="fill" className="w-10 h-10 text-[#FF3B30] mx-auto" />
            <div>
              <p className="text-sm font-semibold text-white">Erro de autenticação</p>
              <p className="text-xs text-[#8aa9c9] mt-2 break-words">{error}</p>
            </div>
            <button
              data-testid="btn-voltar-login"
              onClick={() => navigate("/login")}
              className="w-full py-2 bg-[#40B6A2] text-[#061729] font-semibold text-sm rounded-sm hover:bg-[#359a89]"
            >
              Voltar ao login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
